import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLICK_AND_COLLECT } from '../../brands/default/constants';
import { BASKET_DEAL_PRODUCT_DELIVERY } from '../../brands/default/content/components/checkout';
import { trackEvent, updateDod } from '../../helpers/analytics';
import { formatCurrency } from '../../helpers/currency';
import { formatDeliveryDate } from '../../helpers/date';
import ThemeContext from '../../providers/ThemeProvider';
import { updateProductDeliveryOptionType } from '../../redux/actions/basket';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';
import RadioButtonWithLabel from '../_generic/radio-button/RadioButtonWithLabel';

export default function BasketDealProductDelivery({ bt, deal, product }) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const disabled = useSelector(
    (state) =>
      state.checkout.status === CHECKOUT_STATUS.UPDATING ||
      state.checkout.status === CHECKOUT_STATUS.REFRESHING,
  );

  useEffect(() => {
    const deliveryOption = product.productDeliveryOptions.find(
      (option) => product.deliveryOptionType === option.deliveryOptionType,
    );
    updateDod({ deliveryOption: deliveryOption.deliveryOptionName });
  }, []);

  const onChangeDelivery = (event) => {
    const deliveryOption = product.productDeliveryOptions.find(
      (option) =>
        option.deliveryOptionType === Number.parseInt(event.target.value, 10),
    );
    updateDod({ deliveryOption: deliveryOption.deliveryOptionName });
    trackEvent(`CHANGED_DELIVERY_OPTION_TO`);
    dispatch(updateProductDeliveryOptionType(bt, product, event.target.value));
  };

  return (
    <>
      <div className="delivery">
        <h3 className="delivery__title">Delivery Options</h3>
        {product.productDeliveryOptions.map((option) => {
          const date = formatDeliveryDate(option.estimatedDeliveryDate);

          if (option.deliveryOptionName.includes(CLICK_AND_COLLECT)) {
            return null;
          }

          return (
            <RadioButtonWithLabel
              checked={product.deliveryOptionType === option.deliveryOptionType}
              disabled={disabled}
              key={`delivery-option-${option.deliveryOptionType}`}
              label={
                <p className="delivery__label">
                  <span>{option.deliveryOptionName}</span>{' '}
                  <span className="delivery__green">
                    ({BASKET_DEAL_PRODUCT_DELIVERY.getItBy} {date}*)
                  </span>
                  <span className="delivery__bold">
                    {' '}
                    -{' '}
                    {formatCurrency(
                      deal?.currency,
                      option.customerPostageCost,
                      true,
                      false,
                    )}
                    &nbsp;&nbsp;
                  </span>
                </p>
              }
              onChange={onChangeDelivery}
              value={option.deliveryOptionType}
            />
          );
        })}
        <p className="delivery__annotation">
          *{BASKET_DEAL_PRODUCT_DELIVERY.mustRedeemToday}
        </p>
      </div>
      <style jsx>{`
        .delivery {
          width: 60%;
          margin-left: auto;
          margin-top: 20px;
        }
        .delivery__title {
          margin-left: 10px;
        }
        .delivery__label {
          margin: 0;
        }
        .delivery__green {
          color: ${theme.colors.socialcuecolor.assure};
        }
        .delivery__bold {
          font-weight: bold;
        }
        .delivery__annotation {
          font-size: 12px;
          margin-top: 5px;
          margin-left: 10px;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .delivery {
            width: 75%;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .delivery {
            width: 100%;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .product {
            flex-direction: column;
          }
          .product__image {
            width: 100%;
          }
          .product__details {
            padding-left: 0;
          }
          .product__title-link {
            display: none;
          }
          .product__title-link--mobile {
            display: block;
          }
          .product__social-cue {
            text-align: center;
          }
        }
      `}</style>
    </>
  );
}

BasketDealProductDelivery.propTypes = {
  bt: PropTypes.string,
  deal: PropTypes.object,
  product: PropTypes.object,
};
